<template>
    <div>
        <h3>File Search Results</h3>
        <h4>Projects</h4>
        <h4>Cultural Resources</h4>
        <h4>Isolated Finds</h4>
    </div>
</template>


<script>
import loggingService from '../services/util/loggingService'
//import fileSearchService from '../services/fileSearchService'

import loader from '../components/Loader.vue'
export default {
    components: {
        loader
    },
    data () {
        return {
            isDebug: false,
            loading: true
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'FileSearches', 'mounted')

        this.loadData()
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'FileSearches', 'loadData')
        }
    }
}
</script>



// WEBPACK FOOTER //
// FileSearchResults.vue?e1de23fc